import { ReactNode } from "react";
import { useOutletContext } from "react-router-dom";

import { useMunicipalPropertyYearMutations } from "@/domain/municipal-property/hooks/api/use-municipal-property-year-mutations";
import { MunicipalPropertyYearQuery } from "@/graphql/generated/graphql";

interface MunicipalPropertyYearPageContext {
  readonly removeYearAction?: ReactNode;
  readonly year: MunicipalPropertyYearQuery["municipalPropertyYear"];
  readonly canWrite: boolean;
  readonly mutation: ReturnType<typeof useMunicipalPropertyYearMutations>;
}

export function useMunicipalPropertyYearPageContext(): MunicipalPropertyYearPageContext {
  return useOutletContext<MunicipalPropertyYearPageContext>();
}
